import store from "../store";
import CandidateFunctions from '@/classes/CandidateFunctions';

export default async ({next, router}) => {
    
    if (CandidateFunctions.getCandidateToken()) {
        
        if (!store.getters['candidate/getCandidateId']) {
            await CandidateFunctions.loadCandidate().then(() => {
                return router.push({name: 'auth.success'}).catch(()=>{});
            });
        }
        
        return router.push({name: 'auth.success'}).catch(()=>{});
    }
    
    return next();
}
